var styles = {
  "Header": "Online-Store-UI-Header_1d1yi",
  "Interior": "Online-Store-UI-Header__Interior_9sr3v",
  "SecondaryAction": "Online-Store-UI-Header__SecondaryAction_oovfs",
  "PrimaryAction": "Online-Store-UI-Header__PrimaryAction_1a7ft",
  "PrimaryActionGroup": "Online-Store-UI-Header__PrimaryActionGroup_ahmig",
  "PrimaryActionGroupWrapper": "Online-Store-UI-Header__PrimaryActionGroupWrapper_v6iu0",
  "MiddleAction": "Online-Store-UI-Header__MiddleAction_pbes1",
  "MiddleActionInteractive": "Online-Store-UI-Header__MiddleActionInteractive_1c8fl",
  "MiddleActionButton": "Online-Store-UI-Header__MiddleActionButton_1e7oq",
  "DragHandleIcon": "Online-Store-UI-Header__DragHandleIcon_11uck",
  "Title": "Online-Store-UI-Header__Title_1rmep",
  "TitleWrapper": "Online-Store-UI-Header__TitleWrapper_hw0p9",
  "SubtitleWrapper": "Online-Store-UI-Header__SubtitleWrapper_1qrkw",
  "TitlePrefixWrapper": "Online-Store-UI-Header__TitlePrefixWrapper_1rxz5",
  "SubtitlePrefixWrapper": "Online-Store-UI-Header__SubtitlePrefixWrapper_qslq8",
  "SubtitleSuffixWrapper": "Online-Store-UI-Header__SubtitleSuffixWrapper_vbxi9",
  "SuffixWrapper": "Online-Store-UI-Header__SuffixWrapper_ijgmo",
  "Button": "Online-Store-UI-Header__Button_15eo8",
  "semibold": "Online-Store-UI-Header--semibold_1pojc",
  "alignRight": "Online-Store-UI-Header--alignRight_1oqj1",
  "ButtonContentWrapper": "Online-Store-UI-Header__ButtonContentWrapper_1rdv1",
  "hasPrefix": "Online-Store-UI-Header--hasPrefix_ojvg2",
  "Prefix": "Online-Store-UI-Header__Prefix_1lyav",
  "Content": "Online-Store-UI-Header__Content_w9hgz",
  "LoadingSpinner": "Online-Store-UI-Header__LoadingSpinner_1xxy8",
  "PrimaryAndMoreActions": "Online-Store-UI-Header__PrimaryAndMoreActions_cgk7x"
};

export { styles as default };
